export const LECTOR_MOCKUP = {
  DELETE_CONTACT: {
    success: true,
    data: {},
    code: 200,
    msg: "Contacto bloqueado con éxito.",
  },
};